import { getAssetIconBySymbol } from 'abis/set/asset-icons'
import { CoverInformation } from 'components/index-cover/cover-info'
import type { GradientTagline } from 'components/index-cover/services'
import {
  BgWrapper,
  CoverOverview,
  CustomIcon,
  DescriptionText,
  GradientText,
  IndexInfo,
  LogoWrapper,
  RegularText,
  SeparatorLine,
  TextWrapper,
  Title,
} from 'components/index-cover/styled'
import type { ProductMetadata } from 'indices-list'

type CoverInforo = {
  label: string
  value: string
  color?: string
}

type CoverInformationProps = {
  productMetaData: ProductMetadata
  coverInformation: CoverInforo[]
  tagLineModifier: (product: ProductMetadata) => GradientTagline
}

interface CoverProps {
  productMetadata: ProductMetadata
  tagLineModifier: (product: ProductMetadata) => GradientTagline
}

export const Cover: React.FC<CoverProps> = ({ productMetadata, tagLineModifier }) => {
  const { longName, symbol } = productMetadata

  const { regularText, gradientText } = tagLineModifier(productMetadata)

  return (
    <>
      <BgWrapper>
        <LogoWrapper>
          <CustomIcon src={getAssetIconBySymbol(productMetadata.symbol.toUpperCase())} />
        </LogoWrapper>
        <TextWrapper>
          <Title>{symbol.toUpperCase()}</Title>
          <IndexInfo>{`| ${longName}`}</IndexInfo>
        </TextWrapper>
      </BgWrapper>

      <RegularText>
        {regularText}

        <GradientText
          isCapitalized={true}
          firstColor={productMetadata.brandColour}
          secondColor={productMetadata.additionalBrandColour}
        >
          {gradientText}
        </GradientText>
      </RegularText>

      <DescriptionText>{productMetadata.description}</DescriptionText>
    </>
  )
}

export const StakingCoverInformation: React.FC<CoverInformationProps> = ({
  coverInformation,
  productMetaData,
  tagLineModifier,
}) => {
  return (
    <CoverOverview>
      <Cover productMetadata={productMetaData} tagLineModifier={tagLineModifier} />
      <SeparatorLine />
      <CoverInformation coverInformation={coverInformation} />
    </CoverOverview>
  )
}
